import { ListExpertCollectionsResponse } from '@cbinsights/collectionservice/collectionservice';
import {
  CreateDataFeedConfigRequest,
  CreateDataFeedConfigResponse,
  DeleteDataFeedConfigRequest,
  GetDataFeedConfigRequest,
  GetDataFeedConfigResponse,
  GetOptionalColumnCatalogResponse,
  ListDataFeedConfigRequest,
  ListDataFeedConfigResponse,
  SetDataFeedActiveRequest,
  SetDataFeedActiveResponse,
  UpdateDataFeedConfigRequest,
} from '@cbinsights/externalapiservice/externalapiservice';
import { Empty } from 'client/@types/google/protobuf/empty';
import type { V2FirmographicsFirmographicsRequestBody } from 'client/@types/external-api-v2';
import { request } from 'client/modules/common/utils/request';
import {
  GetSearchMultiRequest,
  MultiSearchResponse,
} from '@cbinsights/integratedsearchservice/integratedsearchservice';

export const listExpertCollections =
  (): Promise<ListExpertCollectionsResponse> =>
    request({
      url: '/service/collectionservice/ListExpertCollections',
    }).then((r) => r.body);

/**
 * The firmographics IDs endpoint is not exposed publicly and so is not in the
 * OpenAPI spec. This adds the extra fields in that endpoint.
 */
export interface V2FirmographicsIdsRequestBody
  extends V2FirmographicsFirmographicsRequestBody {
  tier1Only?: boolean;
  descriptions?: string[];
  isCompany?: boolean;
  isInvestor?: boolean;
  minDealDate?: string;
  maxDealDate?: string;
}

export const createDataFeedConfig = (
  req: IndexSignature<CreateDataFeedConfigRequest>
): Promise<CreateDataFeedConfigResponse> =>
  request({
    url: '/service/externalapiservice/CreateDataFeedConfig',
    body: req,
  }).then((r) => r.body);

export const listDataFeedConfig = (
  req: IndexSignature<ListDataFeedConfigRequest>
): Promise<ListDataFeedConfigResponse> =>
  request({
    url: '/service/externalapiservice/ListDataFeedConfig',
    body: req,
  }).then((r) => r.body);

export const deleteDataFeedConfig = (
  req: IndexSignature<DeleteDataFeedConfigRequest>
): Promise<Empty> =>
  request({
    url: '/service/externalapiservice/DeleteDataFeedConfig',
    body: req,
  }).then((r) => r.body);

export const getDataFeedConfig = (
  req: IndexSignature<GetDataFeedConfigRequest>
): Promise<GetDataFeedConfigResponse> =>
  request({
    url: '/service/externalapiservice/GetDataFeedConfig',
    body: req,
  }).then((r) => r.body);

export const updateDataFeedConfig = (
  req: IndexSignature<UpdateDataFeedConfigRequest>
): Promise<Empty> =>
  request({
    url: '/service/externalapiservice/UpdateDataFeedConfig',
    body: req,
  }).then((r) => r.body);

export const setDataFeedActive = (
  req: IndexSignature<SetDataFeedActiveRequest>
): Promise<SetDataFeedActiveResponse> =>
  request({
    url: '/service/externalapiservice/SetDataFeedActive',
    body: req,
  }).then((r) => r.body);

export const getOptionalColumnCatalog =
  (): Promise<GetOptionalColumnCatalogResponse> =>
    request({
      url: '/service/externalapiservice/GetOptionalColumnCatalog',
    }).then((r) => r.body);

export const getMultiSearch = (
  req: IndexSignature<GetSearchMultiRequest>
): Promise<MultiSearchResponse> =>
  request({
    url: '/service/integratedsearchservice/GetSearchMulti',
    body: req,
  }).then((r) => r.body);
